/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const redo_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.375 21.25a9.375 9.375 0 1 1 9.375-9.375V13.5m0 0-3.25-3.25m3.25 3.25L23 10.25"
    />
  </svg>
)
export default redo_medium
